<template>
    <form
        class="contact-view contact-details-form"
        @submit.prevent="sendForm()"
        name="contact-form"
    >
        <div class="account-view__content">
            <div class="account-view__section">
                <div class="container is-max-desktop">
                    <h1 class="title is-2 has-text-grey">
                        {{ $t('forms.contactForm.header') }}
                    </h1>
                </div>
            </div>
        </div>
        <div class="account-view__section">
            <div class="container is-max-desktop">
                <div class="columns is-multiline is-centered">
                    <div class="column is-half-tablet">
                        <b-field :label="`${$t('forms.labels.firstName')} *`">
                            <b-input
                                v-model="contactDetails.firstName"
                                :placeholder="$t('forms.labels.firstName')"
                                maxlength="20"
                                :has-counter="false"
                            ></b-input>
                        </b-field>
                    </div>
                    <div class="column is-half-tablet">
                        <b-field :label="`${$t('forms.labels.lastName')} *`">
                            <b-input
                                v-model="contactDetails.lastName"
                                :placeholder="$t('forms.labels.lastName')"
                                maxlength="20"
                                :has-counter="false"
                            ></b-input>
                        </b-field>
                    </div>
                    <div class="column is-half-tablet">
                        <b-field :label="`${$t('forms.labels.email')} *`">
                            <b-input
                                v-model="contactDetails.mail"
                                type="email"
                                :placeholder="$t('forms.labels.email')"
                                :has-counter="false"
                            ></b-input>
                        </b-field>
                    </div>
                    <div class="column is-half-tablet">
                        <b-field :label="`${$t('forms.labels.phone')} *`">
                            <b-input
                                v-model="contactDetails.phone"
                                :placeholder="$t('forms.labels.phone')"
                                type="tel"
                                :has-counter="false"
                            ></b-input>
                        </b-field>
                    </div>
                    <div class="column is-full-tablet">
                        <b-field
                            :label="`${$t(
                                'forms.contactForm.labels.subject'
                            )} *`"
                        >
                            <b-input
                                v-model="contactDetails.subject"
                                :placeholder="
                                    $t('forms.contactForm.labels.subject')
                                "
                                maxlength="50"
                                :has-counter="false"
                            ></b-input>
                        </b-field>
                    </div>
                    <div class="column is-full-tablet">
                        <b-checkbox v-model="contactDetails.isBugReport">{{
                            $t('forms.contactForm.labels.reportABug')
                        }}</b-checkbox>
                        <p
                            v-if="contactDetails.isBugReport"
                            class="is-size-5"
                            v-html="$t('forms.bugReport.descriptions.general')"
                        ></p>
                        <p
                            v-if="contactDetails.isBugReport"
                            class="is-size-6 mt-5"
                            v-html="
                                $t(
                                    'forms.bugReport.descriptions.optionalFields'
                                )
                            "
                        ></p>
                    </div>
                    <template v-if="contactDetails.isBugReport">
                        <div class="column is-full">
                            <b-field
                                :label="`${$t(
                                    'forms.bugReport.labels.userIntention'
                                )}`"
                            >
                                <b-input
                                    v-model="contactDetails.userIntention"
                                    :placeholder="
                                        $t(
                                            'forms.bugReport.descriptions.userIntention'
                                        )
                                    "
                                    :has-counter="false"
                                ></b-input>
                            </b-field>
                        </div>
                        <div class="column is-full">
                            <b-field
                                :label="`${$t(
                                    'forms.bugReport.labels.userExpectation'
                                )}`"
                            >
                                <b-input
                                    v-model="contactDetails.userExpectation"
                                    :placeholder="
                                        $t(
                                            'forms.bugReport.descriptions.userExpectation'
                                        )
                                    "
                                    :has-counter="false"
                                ></b-input>
                            </b-field>
                        </div>
                        <div class="column is-full">
                            <b-field
                                :label="`${$t(
                                    'forms.bugReport.labels.systemResponse'
                                )}`"
                            >
                                <b-input
                                    v-model="contactDetails.systemResponse"
                                    :placeholder="
                                        $t(
                                            'forms.bugReport.descriptions.systemResponse'
                                        )
                                    "
                                    :has-counter="false"
                                ></b-input>
                            </b-field>
                        </div>
                        <div class="column is-half-tablet">
                            <div class="label">
                                {{ $t('forms.bugReport.labels.browserUsed') }}
                            </div>
                            <b-select
                                expanded
                                v-model="contactDetails.browserUsed"
                                ><option
                                    v-for="browser in availableBrowsers"
                                    :value="browser"
                                    :key="`browser-option_${browser}`"
                                >
                                    {{ browser }}
                                </option>
                                <option value="different">
                                    {{
                                        $t(
                                            'forms.bugReport.labels.otherBrowser'
                                        )
                                    }}
                                </option></b-select
                            >
                        </div>
                        <div class="column is-half-tablet">
                            <div
                                class="is-flex is-flex-direction-column is-justify-content-space-between is-flex-wrap-wrap"
                                style="height: 100%"
                            >
                                <div class="label" style="width: 100%">
                                    {{
                                        $t(
                                            'forms.bugReport.labels.problemPersistInAnotherBrowser'
                                        )
                                    }}
                                </div>
                                <div style="width: 100%">
                                    <b-checkbox
                                        v-for="browser in availableBrowsers.filter(
                                            (browser) =>
                                                browser !==
                                                contactDetails.browserUsed
                                        )"
                                        v-model="
                                            contactDetails.differentBrowsers
                                        "
                                        :native-value="browser"
                                        :key="`browser-option_${browser}`"
                                    >
                                        {{ browser }}
                                    </b-checkbox>
                                    <b-checkbox
                                        @input="
                                            contactDetails.differentBrowsers =
                                                []
                                        "
                                    >
                                        {{
                                            $t(
                                                'forms.bugReport.labels.iDontKnow'
                                            )
                                        }}
                                    </b-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half-tablet">
                            <div class="label">
                                {{ $t('forms.bugReport.labels.osUsed') }}
                            </div>
                            <b-select expanded v-model="contactDetails.osUsed"
                                ><option
                                    v-for="os in availableOS"
                                    :value="os"
                                    :key="`browser-option_${os}`"
                                >
                                    {{ os }}
                                </option>
                                <option value="different">
                                    {{ $t('forms.bugReport.labels.otherOs') }}
                                </option></b-select
                            >
                        </div>
                        <div class="column is-half-tablet">
                            <div
                                class="is-flex is-flex-direction-column is-justify-content-space-between is-flex-wrap-wrap"
                                style="height: 100%"
                            >
                                <div
                                    class="label"
                                    style="width: 100%"
                                    v-html="
                                        $t(
                                            'forms.bugReport.labels.internetConnection'
                                        )
                                    "
                                ></div>

                                <div>
                                    <b-radio
                                        class="mr-4"
                                        v-model="
                                            contactDetails.userCheckedInternetConnection
                                        "
                                        native-value="yes"
                                    >
                                        {{ $t('forms.bugReport.labels.yes') }}
                                    </b-radio>
                                    <b-radio
                                        v-model="
                                            contactDetails.userCheckedInternetConnection
                                        "
                                        native-value="no"
                                    >
                                        {{ $t('forms.bugReport.labels.no') }}
                                    </b-radio>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half">
                            <div class="label" style="width: 100%">
                                {{
                                    $t(
                                        'forms.bugReport.labels.errorMessageOccurred'
                                    )
                                }}
                            </div>

                            <div>
                                <b-radio
                                    class="mr-4"
                                    v-model="
                                        contactDetails.errorMessageOccurred
                                    "
                                    :native-value="true"
                                >
                                    {{ $t('forms.bugReport.labels.yes') }}
                                </b-radio>
                                <b-radio
                                    v-model="
                                        contactDetails.errorMessageOccurred
                                    "
                                    :native-value="false"
                                >
                                    {{ $t('forms.bugReport.labels.no') }}
                                </b-radio>
                            </div>
                        </div>
                        <div class="column is-half">
                            <b-field
                                :label="`${$t(
                                    'forms.bugReport.labels.errorMessage'
                                )}`"
                            >
                                <b-input
                                    v-model="contactDetails.errorMessage"
                                    :disabled="
                                        !contactDetails.errorMessageOccurred
                                    "
                                    :placeholder="
                                        $t(
                                            'forms.bugReport.labels.errorMessage'
                                        )
                                    "
                                    :has-counter="false"
                                ></b-input>
                            </b-field>
                        </div>
                        <div class="column is-full-tablet">
                            <b-field
                                :label="`${$t(
                                    'forms.bugReport.labels.description'
                                )} *`"
                            >
                                <b-input
                                    v-model="contactDetails.message"
                                    :placeholder="
                                        $tc(
                                            'forms.contactForm.hints.maxNCharacters',
                                            400
                                        )
                                    "
                                    maxlength="400"
                                    :has-counter="false"
                                    type="textarea"
                                ></b-input>
                            </b-field>
                        </div>
                    </template>
                    <template v-else>
                        <div class="column is-full-tablet">
                            <b-field
                                :label="`${$t(
                                    'forms.contactForm.labels.message'
                                )} *`"
                            >
                                <b-input
                                    v-model="contactDetails.message"
                                    :placeholder="
                                        $tc(
                                            'forms.contactForm.hints.maxNCharacters',
                                            400
                                        )
                                    "
                                    required
                                    maxlength="400"
                                    :has-counter="false"
                                    type="textarea"
                                ></b-input>
                            </b-field>
                        </div>
                    </template>

                    <div class="column is-full">
                        <div
                            class="is-flex-tablet is-justify-content-space-between pr-5"
                        >
                            <b-checkbox
                                v-model="contactDetails.confirmation"
                                class="mb-3"
                                style="max-width: 600px"
                            >
                                <span
                                    v-html="$t('forms.labels.privacyAgreement')"
                                />
                            </b-checkbox>
                            <b-button
                                native-type="submit"
                                :title="
                                    !allRequiredFieldsAreFilled &&
                                    $t('forms.hints.requiredFieldsMissing')
                                "
                                :disabled="!allRequiredFieldsAreFilled"
                                :expanded="
                                    currentViewport === viewports.MOBILE.name
                                "
                                icon-right="arrow-right"
                                class="button is-primary-dark px-6"
                            >
                                <span
                                    class="is-flex is-justify-content-space-between is-align-items-center"
                                >
                                    {{ $t('forms.labels.submit') }}
                                    <SvgIcon
                                        icon="icon--directional_arrow-right"
                                        class="is-light ml-5"
                                /></span>
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import SvgIcon from '../svg/SvgIcon';
import axios from 'axios';
import { eventBus } from '../../events/event-bus';
import convertToFormDataObject from '../../utilities/convert-to-form-data';
import { mapGetters } from 'vuex';
import { viewports } from '../../store/constants/viewports';

export default {
    name: 'ContactForm',
    components: { SvgIcon },
    data() {
        return {
            viewports,
            contactDetails: {
                firstName: '',
                lastName: '',
                phone: '',
                mail: '',
                subject: '',
                message: '',
                userExpectation: '',
                userIntention: '',
                systemResponse: '',
                userCheckedInternetConnection: 'yes',
                errorMessage: '',
                browserUsed: 'Mozilla Firefox',
                osUsed: 'Microsoft Windows',
                differentBrowsers: [],
                isBugReport: false,
                confirmation: false,
                errorMessageOccurred: true,
            },
            availableBrowsers: [
                'Mozilla Firefox',
                'Google Chrome',
                'Apple Safari',
                'Microsoft Edge',
            ],
            availableOS: [
                'Microsoft Windows',
                'Apple MacOS',
                'Apple iOS',
                'Android',
            ],
            requiredFields: [
                'firstName',
                'lastName',
                'mail',
                'message',
                'confirmation',
            ],
            API_URL: 'https://3d-print.jomatik.de/rest_api',
        };
    },
    computed: {
        ...mapGetters(['currentViewport']),
        allRequiredFieldsAreFilled() {
            let result = true;
            this.requiredFields.forEach((value) => {
                if (!this.contactDetails[value]) {
                    result = false;
                }
            });
            return result;
        },
    },
    methods: {
        sendForm() {
            axios
                .post(
                    this.API_URL + '/ContactForm.php',
                    convertToFormDataObject(this.contactDetails),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                    }
                )
                .then(() => {
                    eventBus.notification({
                        type: 'success',
                        header: 'Absenden erfolgreich',
                        body: 'Ihre Anfrage wurde versendet. Wir melden uns in Kürze bei Ihnen zurück.',
                    });
                    this.$router.push('/');
                })
                .catch(function () {
                    eventBus.notification({
                        type: 'warning',
                        header: 'Hier scheint ein Fehler aufgetreten zu sein.',
                        body: 'Ihre Anfrage konnte nicht versendet werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                    });
                });
        },
    },
};
</script>

<style scoped></style>
